var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGroups = function SvgGroups(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "groups_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#groups_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#56565C",
    d: "M.5 17.8v-1.225q0-1 1.038-1.637 1.037-.639 2.712-.638.274 0 .562.012t.563.063a4.6 4.6 0 0 0-.425.975q-.15.5-.15 1.025V17.8zm6 0v-1.375q0-.726.4-1.3t1.125-1q.75-.45 1.763-.663A10.8 10.8 0 0 1 12 13.25q1.226 0 2.238.212 1.013.213 1.737.663.75.425 1.138 1 .387.574.387 1.3V17.8zm12.7 0v-1.425q0-.55-.138-1.05a3.7 3.7 0 0 0-.412-.95q.3-.051.575-.063t.525-.012q1.675 0 2.712.625 1.038.624 1.038 1.65V17.8zM8.075 16.3h7.875v-.125q-.175-.6-1.287-1.013Q13.55 14.75 12 14.75t-2.662.412q-1.113.413-1.263 1.013zM4.25 13.325q-.7 0-1.2-.513a1.68 1.68 0 0 1-.5-1.212q0-.7.5-1.2t1.2-.5q.725 0 1.225.5t.5 1.2-.5 1.212a1.65 1.65 0 0 1-1.225.513m15.5 0q-.7 0-1.2-.513a1.68 1.68 0 0 1-.5-1.212q0-.7.5-1.2t1.2-.5q.725 0 1.213.5.487.5.487 1.2a1.7 1.7 0 0 1-.487 1.212q-.488.513-1.213.513M12 12.5a2.5 2.5 0 0 1-1.837-.762A2.5 2.5 0 0 1 9.4 9.9q0-1.1.763-1.85.762-.75 1.837-.75 1.1 0 1.85.75t.75 1.85q0 1.075-.75 1.838-.75.762-1.85.762m0-1.5q.476 0 .788-.325A1.08 1.08 0 0 0 13.1 9.9q0-.45-.312-.775A1.05 1.05 0 0 0 12 8.8q-.45 0-.775.325a1.06 1.06 0 0 0-.325.775q0 .45.325.775.325.324.775.325"
  }))));
};
export default SvgGroups;